/** Temporary manual-order flow. No card details or payment are collected here. */
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-eb-email-purchase]');
  if (!link || event.defaultPrevented) return;

  const form = link.closest('product-form-component')?.querySelector('form');
  const destination = new URL(link.href, window.location.origin);
  const variantId = form?.querySelector('[name="id"]')?.value;
  const quantity = form?.querySelector('[name="quantity"]')?.value;

  if (variantId) destination.searchParams.set('variant', variantId);
  if (quantity && Number(quantity) > 0) destination.searchParams.set('quantity', quantity);

  // Keep Ctrl/Cmd-click and opening in another tab consistent with a normal link.
  link.href = destination.toString();
}, true);

const assistance = document.querySelector('[data-eb-purchase-assistance]');
if (assistance) {
  const params = new URLSearchParams(window.location.search);
  const isProduct = params.get('source') === 'product';
  const productPanel = assistance.querySelector('[data-eb-single-product]');
  const cartPanel = assistance.querySelector('[data-eb-cart-products]');
  const emailLink = assistance.querySelector('[data-eb-order-email]');
  const address = 'customerservice@ethanbing.com';
  const zh = document.documentElement.lang.toLowerCase().startsWith('zh');
  const lines = zh
    ? ['ETHAN BING 客户服务团队，您好：', '', '我想咨询购买以下商品：', '']
    : ['Dear ETHAN BING Client Services,', '', 'I would like to enquire about the following purchase:', ''];

  if (isProduct) {
    const name = (params.get('product') || (zh ? '商品咨询' : 'Product enquiry')).trim().slice(0, 180);
    const variant = (params.get('variant') || '').replace(/[^\d]/g, '').slice(0, 24);
    const quantity = Math.max(1, Math.min(9999, Number.parseInt(params.get('quantity') || '1', 10) || 1));
    const nameElement = productPanel?.querySelector('[data-eb-product-name]');
    const detailElement = productPanel?.querySelector('[data-eb-product-detail]');

    if (nameElement) nameElement.textContent = name;
    if (detailElement) detailElement.textContent = zh ? `数量：${quantity}${variant ? ` · 款式编号：${variant}` : ''}` : `Quantity: ${quantity}${variant ? ` · Variant ID: ${variant}` : ''}`;
    if (productPanel) productPanel.hidden = false;
    if (cartPanel) cartPanel.hidden = true;

    lines.push(zh ? `${name} — 数量 ${quantity}${variant ? ` — 款式编号 ${variant}` : ''}` : `${name} — quantity ${quantity}${variant ? ` — variant ID ${variant}` : ''}`);

    const productPath = params.get('url');
    if (productPath) {
      try {
        const productURL = new URL(productPath, window.location.origin);
        if (productURL.origin === window.location.origin && /\/products\//.test(productURL.pathname)) {
          if (variant) productURL.searchParams.set('variant', variant);
          lines.push(productURL.href);
        }
      } catch {
        // The email still includes the product name and selected variant.
      }
    }
  } else {
    const items = [...assistance.querySelectorAll('[data-eb-cart-item]')];
    if (items.length) {
      items.forEach((item) => {
        const title = item.getAttribute('data-eb-title') || (zh ? '商品' : 'Product');
        const variant = item.getAttribute('data-eb-variant') || '';
        const quantity = item.getAttribute('data-eb-quantity') || '1';
        lines.push(zh ? `${title} — 数量 ${quantity}${variant ? ` — 款式：${variant}` : ''}` : `${title} — quantity ${quantity}${variant ? ` — variant: ${variant}` : ''}`);
      });
    } else {
      lines.push(zh ? '请告知如何下单。' : 'Please let me know how to place an order.');
    }
  }

  lines.push('', zh ? '请协助确认库存、最终价格、配送方式及安全付款安排。' : 'Please confirm availability, the final price, delivery options and secure payment arrangements.', '', zh ? '谢谢！' : 'Thank you.');
  const subject = zh ? (isProduct ? 'ETHAN BING — 商品购买咨询' : 'ETHAN BING — 购物车购买咨询') : (isProduct ? 'ETHAN BING — product purchase enquiry' : 'ETHAN BING — cart purchase enquiry');
  if (emailLink) {
    emailLink.href = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
  }
}
